import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
	
    private subject = new BehaviorSubject<any | undefined>(undefined);

    sendMessage(message: any) {
        this.subject.next({ text: message });
    }

    clearMessage() {
        this.subject.next(false);
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}
	  